<template>
  <div>
    <H5Share v-if="isH5" />
    <Share v-else />
  </div>
</template>

<script>
import { isH5, isMGAppInPad } from "@saas/components/src";
import H5Share from "./H5Share.vue";
import Share from "./Share.vue";
export default {
  components: { H5Share, Share },
  data: function () {
    return {
      isH5: false,
      isMGAppInPad: false,
    };
  },
  created() {
    // this.isMGAppInPad = isMGAppInPad();
    this.isH5 = isH5();
  },
};
</script>

<style></style>
